//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WidgetPanel from './widget-panel/index';
import ToolbarPanel from './toolbar-panel/index';
import SettingPanel from './setting-panel/index';
import VFormWidget from './form-widget/index';
import { createDesigner } from '@/components/form-designer/designer';
import { addWindowResizeHandler, deepClone, getAllContainerWidgets, getAllFieldWidgets, getQueryParam, traverseAllWidgets } from '@/utils/util';
import i18n, { changeLocale } from '@/utils/i18n';
import axios from 'axios';
// import SvgIcon from '@/components/svg-icon'

export default {
  name: 'VFormDesigner',
  componentName: 'VFormDesigner',
  mixins: [i18n],
  components: {
    WidgetPanel: WidgetPanel,
    ToolbarPanel: ToolbarPanel,
    SettingPanel: SettingPanel,
    VFormWidget: VFormWidget
    // SvgIcon
  },
  props: {
    /* 后端字段列表API */
    fieldListApi: {
      type: Object,
      default: null
    },
    /* 禁止显示的组件名称数组 */
    bannedWidgets: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    designerConfig: {
      type: Object,
      default: function _default() {
        return {
          eventCollapse: true,
          //是否显示组件事件属性折叠面板
          widgetNameReadonly: false,
          //禁止修改组件名称

          clearDesignerButton: true,
          //是否显示清空设计器按钮
          previewFormButton: true,
          //是否显示预览表单按钮
          importJsonButton: true,
          //是否显示导入JSON按钮
          exportJsonButton: true,
          //是否显示导出JSON器按钮
          exportCodeButton: true,
          //是否显示导出代码按钮
          generateSFCButton: true,
          //是否显示生成SFC按钮
          toolbarMaxWidth: 200,
          //设计器工具按钮栏最大宽度（单位像素）
          toolbarMinWidth: 300,
          //设计器工具按钮栏最小宽度（单位像素）

          presetCssCode: '',
          //设计器预设CSS样式代码
          resetFormJson: false //是否在设计器初始化时将表单内容重置为空
        };
      }
    },
    /* 全局数据源变量 */
    globalDsv: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      curLangName: '',
      vsCodeFlag: false,
      caseName: '',
      scrollerHeight: 0,
      designer: createDesigner(this),
      fieldList: []
    };
  },
  provide: function provide() {
    var _this = this;
    return {
      serverFieldList: this.fieldList,
      getDesignerConfig: function getDesignerConfig() {
        return _this.designerConfig;
      },
      getBannedWidgets: function getBannedWidgets() {
        return _this.bannedWidgets;
      },
      getReadMode: function getReadMode() {
        return false;
      }
    };
  },
  created: function created() {
    this.vsCodeFlag = getQueryParam('vscode') == 1;
    this.caseName = getQueryParam('case');
  },
  mounted: function mounted() {
    var _this2 = this;
    this.initLocale();
    this.scrollerHeight = window.innerHeight - 250 + 'px';
    addWindowResizeHandler(function () {
      _this2.$nextTick(function () {
        _this2.scrollerHeight = window.innerHeight - 250 + 'px';
      });
    });
    this.loadFieldListFromServer();
  },
  methods: {
    onEnd: function onEnd(e) {
      console.log('onEnd', e);
    },
    showLink: function showLink(configName) {
      if (this.designerConfig[configName] === undefined) {
        return true;
      }
      return !!this.designerConfig[configName];
    },
    openHome: function openHome() {
      if (!!this.vsCodeFlag) {
        var msgObj = {
          cmd: 'openUrl',
          data: {
            url: 'https://www.vform666.com/'
          }
        };
        window.parent.postMessage(msgObj, '*');
      }
    },
    openUrl: function openUrl(event, url) {
      if (!!this.vsCodeFlag) {
        var msgObj = {
          cmd: 'openUrl',
          data: {
            url: url
          }
        };
        window.parent.postMessage(msgObj, '*');
      } else {
        var aDom = event.currentTarget;
        aDom.href = url;
        //window.open(url, '_blank') //直接打开新窗口，会被浏览器拦截
      }
    },
    loadCase: function loadCase() {},
    initLocale: function initLocale() {
      var curLocale = localStorage.getItem('form_cache');
      if (!!this.vsCodeFlag) {
        curLocale = curLocale || 'en-US';
      } else {
        curLocale = curLocale || 'zh-CN';
      }
      this.curLangName = this.i18nt('application.' + curLocale);
      this.changeLanguage(curLocale);
    },
    loadFieldListFromServer: function loadFieldListFromServer() {
      var _this3 = this;
      if (!this.fieldListApi) {
        return;
      }
      var headers = this.fieldListApi.headers || {};
      axios.get(this.fieldListApi.URL, {
        headers: headers
      }).then(function (res) {
        var labelKey = _this3.fieldListApi.labelKey || 'label';
        var nameKey = _this3.fieldListApi.nameKey || 'name';
        _this3.fieldList.splice(0, _this3.fieldList.length); //清空已有
        res.data.forEach(function (fieldItem) {
          _this3.fieldList.push({
            label: fieldItem[labelKey],
            name: fieldItem[nameKey]
          });
        });
      }).catch(function (error) {
        _this3.$message.error(error);
      });
    },
    handleLanguageChanged: function handleLanguageChanged(command) {
      this.changeLanguage(command);
      this.curLangName = this.i18nt('application.' + command);
    },
    changeLanguage: function changeLanguage(langName) {
      changeLocale(langName);
    },
    setFormJson: function setFormJson(formJson) {
      var modifiedFlag = false;
      if (!!formJson) {
        if (typeof formJson === 'string') {
          modifiedFlag = this.designer.loadFormJson(JSON.parse(formJson));
        } else if (formJson.constructor === Object) {
          modifiedFlag = this.designer.loadFormJson(formJson);
        }
        if (modifiedFlag) {
          this.designer.emitHistoryChange();
        }
      }
    },
    getFormJson: function getFormJson() {
      return {
        widgetList: deepClone(this.designer.widgetList),
        formConfig: deepClone(this.designer.formConfig)
      };
    },
    clearDesigner: function clearDesigner() {
      this.$refs.toolbarRef.clearFormWidget();
    },
    /**
     * 刷新表单设计器
     */
    refreshDesigner: function refreshDesigner() {
      //this.designer.loadFormJson( this.getFormJson() )  //只有第一次调用生效？？

      var fJson = this.getFormJson();
      this.designer.clearDesigner(true); //不触发历史记录变更
      this.designer.loadFormJson(fJson);
    },
    /**
     * 预览表单
     */
    previewForm: function previewForm() {
      this.$refs.toolbarRef.previewForm();
    },
    /**
     * 导入表单JSON
     */
    importJson: function importJson() {
      this.$refs.toolbarRef.importJson();
    },
    /**
     * 导出表单JSON
     */
    exportJson: function exportJson() {
      this.$refs.toolbarRef.exportJson();
    },
    /**
     * 导出Vue/HTML代码
     */
    exportCode: function exportCode() {
      this.$refs.toolbarRef.exportCode();
    },
    /**
     * 生成SFC代码
     */
    generateSFC: function generateSFC() {
      this.$refs.toolbarRef.generateSFC();
    },
    /**
     * 获取所有字段组件
     * @returns {*[]}
     */
    getFieldWidgets: function getFieldWidgets() {
      var widgetList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return !!widgetList ? getAllFieldWidgets(widgetList) : getAllFieldWidgets(this.designer.widgetList);
    },
    /**
     * 获取所有容器组件
     * @returns {*[]}
     */
    getContainerWidgets: function getContainerWidgets() {
      var widgetList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return !!widgetList ? getAllContainerWidgets(widgetList) : getAllContainerWidgets(this.designer.widgetList);
    },
    /**
     * 升级表单json，以补充最新的组件属性
     * @param formJson
     */
    upgradeFormJson: function upgradeFormJson(formJson) {
      var _this4 = this;
      if (!formJson.widgetList || !formJson.formConfig) {
        this.$message.error('Invalid form json!');
        return;
      }
      traverseAllWidgets(formJson.widgetList, function (w) {
        _this4.designer.upgradeWidgetConfig(w);
      });
      this.designer.upgradeFormConfig(formJson.formConfig);
      return formJson;
    },
    getWidgetRef: function getWidgetRef(widgetName) {
      var showError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return this.$refs['formRef'].getWidgetRef(widgetName, showError);
    },
    getSelectedWidgetRef: function getSelectedWidgetRef() {
      return this.$refs['formRef'].getSelectedWidgetRef();
    } //TODO: 增加更多方法！！
  }
};